import styled from '@emotion/styled';

import { CustomButton } from '../CustomButton';

type FormType = {
  display: string;
  padding: string;
  gap?: string;
};

type CalendarProps = {
  isEditable?: boolean;
};

export const FormGroup: FormType = {
  //Almost all wrappers have these styles.
  display: 'flex',
  padding: '1rem'
};

export const FieldSet = styled.fieldset`
  display: flex;
  border: none;
  height: auto;
  > * + * {
    //lobotomized owl selector . Instead of flex gap this is an alternative
    margin-left: 2rem;
  }
`;
export const AboutTaskStyles = styled.fieldset`
  display: flex;
  border: none;
  height: auto;
  justify-content: space-around;
  padding: 5px;
  > div {
    width: 50%;
    /* margin: 25px; */
    /* border: 1px solid red; */
  }
  > * + * {
    //lobotomized owl selector . Instead of flex gap this is an alternative
    /* display: flex;
      flex-direction: column; */
    /* display: flex;
      flex-direction: column; */
    /* align-self: flex-end; */
    /* align-content: center; */
    /* align-items: flex-start; */
    /* border: 1px solid green; */
    padding-left: 5rem;
    padding-top: 0px;
  }
`;

export const InputWrapper = styled.div`
  ${FormGroup}
  flex-direction: column;
  > * + * {
    //lobotomized owl selector
    margin-top: 10px;
  }
`;
export const DynamicFormInputWrapper = styled.div`
  ${FormGroup}
  flex-direction: column;
  width: 96%;
  > * + * {
    //lobotomized owl selector
    margin-top: 10px;
  }
`;
export const LinkWrapper = styled.div`
  ${FormGroup}
  ${CustomButton} {
    color: #26303e;
    background: #dbe2e0;
    height: 1.8rem;
    font-size: 0.9rem;
    font-weight: 600;
  }
  flex-direction: column;
  > * + * {
    //lobotomized owl selector //Alternative for flex gap property.
    margin-top: 10px;
  }
`;

export const ChoicesWrapper = styled.div`
  ${FormGroup}
  align-items: center;
  > * + * {
    margin-left: 10px;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1rem;
  > * + * {
    margin-left: 10px;
  }
`;

export const DropDownWrapper = styled.div`
  ${FormGroup}
  flex-direction: column;
  > * + * {
    margin-top: 10px;
  }
`;

export const AssigneeWrapper = styled.div`
  ${FormGroup}
  align-items: baseline;
  > * + * {
    margin-top: 10px;
  }
`;
export const ClientWrapper = styled.div`
  ${FormGroup}
  /* border: 1px solid blue; */
  align-items: center;
  > * + * {
    margin-top: 10px;
  }
`;

export const AssigneeSeparator = styled.div`
  //this basically separates the name and time from the avatar icon.
  margin-left: 23px;
  small {
    margin-left: 30px;
  }
`;
export const ClientSeparator = styled.div`
  margin-left: 23px;
  /* align-items: center;
  vertical-align: middle; */
  /* border: 1px solid red;  */
  /* padding-bottom: 5px; */
`;

export const AvatarStyles = styled.div`
  display: flex;
  justify-content: flex-start;
  /* align-items: baseline; */
  align-items: center;
  /* border: 1px solid blue; */
  margin: 0px;
`;

export const DateWrapper = styled.div`
  ${FormGroup}
  align-self: center;
  svg:hover {
    cursor: pointer !important;
  }
  input {
    padding-right: 10px;
  }
  > * + * {
    margin-left: 10px;
  }
`;

export const FileUploadWrapper = styled.div`
  ${FormGroup}
  display: inline-block;
  ${CustomButton} {
    color: #26303e;
    background: #dbe2e0;
    font-size: 0.9rem;
    font-weight: 600;
    height: 29px;
    svg {
      display: inline-block;
      vertical-align: middle;
      margin-right: 15px;
    }
  }
`;

export const FilePreview = styled.div`
  .file {
    margin-left: 0.8rem;
    margin-right: 1.8rem;
  }
  ${CustomButton} {
    display: inline-block;
    height: 1.8rem;
    margin-left: 1.8rem;
  }
  svg {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 4px;
  }
`;

export const CalendarIconPlacer = styled.label<CalendarProps>`
  position: relative;
  :before {
    content: '';
    position: absolute;
    right: ${(props) => (props.isEditable ? '2px' : '3px')};
    top: 0;
    bottom: 0;
    width: 15px;
    background: url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20opacity%3D%220.5%22%20d%3D%22M16%206.4H0V13.6C0%2014.2365%200.252856%2014.847%200.702944%2015.2971C1.15303%2015.7471%201.76348%2016%202.4%2016H13.6C14.2365%2016%2014.847%2015.7471%2015.2971%2015.2971C15.7471%2014.847%2016%2014.2365%2016%2013.6V6.4ZM4%204.8C3.78783%204.8%203.58434%204.71571%203.43431%204.56569C3.28429%204.41566%203.2%204.21217%203.2%204V0.8C3.2%200.587827%203.28429%200.384344%203.43431%200.234315C3.58434%200.0842854%203.78783%200%204%200C4.21217%200%204.41566%200.0842854%204.56569%200.234315C4.71571%200.384344%204.8%200.587827%204.8%200.8V4C4.8%204.21217%204.71571%204.41566%204.56569%204.56569C4.41566%204.71571%204.21217%204.8%204%204.8ZM12%204.8C11.7878%204.8%2011.5843%204.71571%2011.4343%204.56569C11.2843%204.41566%2011.2%204.21217%2011.2%204V0.8C11.2%200.587827%2011.2843%200.384344%2011.4343%200.234315C11.5843%200.0842854%2011.7878%200%2012%200C12.2122%200%2012.4157%200.0842854%2012.5657%200.234315C12.7157%200.384344%2012.8%200.587827%2012.8%200.8V4C12.8%204.21217%2012.7157%204.41566%2012.5657%204.56569C12.4157%204.71571%2012.2122%204.8%2012%204.8Z%22%20fill%3D%22black%22%2F%3E%0A%3Cpath%20d%3D%22M13.6%201.59961H12.8V3.99961C12.8%204.21178%2012.7157%204.41527%2012.5657%204.56529C12.4157%204.71532%2012.2122%204.79961%2012%204.79961C11.7878%204.79961%2011.5843%204.71532%2011.4343%204.56529C11.2843%204.41527%2011.2%204.21178%2011.2%203.99961V1.59961H4.8V3.99961C4.8%204.21178%204.71571%204.41527%204.56569%204.56529C4.41566%204.71532%204.21217%204.79961%204%204.79961C3.78783%204.79961%203.58434%204.71532%203.43431%204.56529C3.28429%204.41527%203.2%204.21178%203.2%203.99961V1.59961H2.4C1.76348%201.59961%201.15303%201.85247%200.702944%202.30255C0.252856%202.75264%200%203.36309%200%203.99961V6.39961H16V3.99961C16%203.36309%2015.7471%202.75264%2015.2971%202.30255C14.847%201.85247%2014.2365%201.59961%2013.6%201.59961Z%22%20fill%3D%22black%22%2F%3E%0A%3C%2Fsvg%3E%0A')
      center / contain no-repeat;
  }
`;

export const WrapperDiv = styled.div`
  ${FormGroup}
  flex-direction: column;
  > * + * {
    margin-top: 10px;
  }
`;

export const SameLineWrapper = styled.div`
  display: flex;
  align-items: center;
  > * + * {
    margin-left: 10px;
  }
`;
